import React, {PureComponent} from 'react';
import autobind from 'autobind-decorator';
import {Col, FormCheck, Row} from 'react-bootstrap';

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";

@SurveyFormInputEnhance
export class SurveyFormInputBoolean extends PureComponent {
    @autobind
    change(value) {
        const { SurveyFormInput, OnChangeOverride } = this.props || {};

        if(OnChangeOverride) {
            OnChangeOverride(this.props, value);
        } else {
            SurveyFormInput?.Change?.(answer => {
                answer.valueBool = value;

                return answer;
            });
        }
    }

    render() {
        const { SurveyFormInput, EditMode } = this.props || {};

        const answer = SurveyFormInput.GetAnswer();
        const boolValue = answer.valueBool;
        const options = SurveyFormInput.GetOptions();
        let boolOptions = [];

        if(options && options.boolValues) {
            boolOptions = options.boolValues;
        }
        if(!EditMode) {
            const current = boolOptions.find((x) => x.value === boolValue);
            return <span>{current ? current.title: ""}</span>;
        }

        return <div className="sb-survey-form-input-boolean">
            {boolOptions.map((x) => <Row key={x.value}>
                    <Col xs={12}>
                        <FormCheck
                            checked={boolValue === x.value}
                            onChange={() => this.change(boolValue === x.value ? null : x.value)}
                            label={x.title}
                        />
                    </Col>
                </Row>
            )}
        </div>;
    }
}


